import { useEffect, useState } from 'react';
import cms_api from '../cms_api';
import { constructField, deepResolveOfs } from '../components/Builder/Library/Types/AttributeSet'
import { filterEntity, isItemVisible } from '../components/PageBuilder/helpers/content';

const formContentsFromData = async (data, connectedObject = null, controlled = false) => {
  const items = data?.items;

  if (!Array.isArray(items)) {
    console.error('Error: Invalid data structure');
    return null; // or handle the error in a way that makes sense for your application
  }

  const resolvedItems = await deepResolveOfs(_.cloneDeep(items));
  return Object.fromEntries(
    resolvedItems.map(filter => [filter.field, constructField(filter, connectedObject, controlled)])
  );
};

const getRouteFromPathParam = path => {
  if (!path) {
    return '/';
  }
  return path?.[0] === '/' ? path : `/${path}`;
};

export const useAttributeSet = (name, path, language, linked_object = null, controlled = false) => {
  const [attributeSetState, setAttributeSetState] = useState({});

  useEffect(() => {
    cms_api
      .get_single_contents({
        filter: {
          type: 'Cms::Content::AttributeSet',
          language_iso_code: language,
          route: getRouteFromPathParam(path),
          name,
        },
        fields: {
          '*': 'contents',
        },
      })
      .then(r => {
        if (r) return formContentsFromData(filterEntity(r, isItemVisible), linked_object, controlled);
        return { name, error: 'not found' };
      })
      .then(r => setAttributeSetState(r));
  }, [name, path]);

  return attributeSetState;
}
